/**
 * Where the app is mounted: "/" when served directly (:8090), or a prefix such as "/studio/" behind a
 * path-routing proxy (Tailscale Funnel). Pages live at <BASE> and <BASE>review/<token>, so every URL
 * the frontend builds goes through here instead of starting with "/".
 */
export const BASE = location.pathname.replace(/review\/[^/]*$/, "").replace(/[^/]*$/, "");

/** "/api/x" -> "<BASE>api/x" */
export const appUrl = (path: string) => BASE + path.replace(/^\//, "");
